// Code generated - EDITING IS FUTILE. DO NOT EDIT.
//
// Generated by:
//     public/app/plugins/gen.go
// Using jennies:
//     TSTypesJenny
//     PluginTsTypesJenny
//
// Run 'make gen-cue' from repository root to regenerate.

// Generated from public/app/plugins/panel/logstable/panelcfg.cue file.

import * as common from '@grafana/schema';

export interface Options {
  buildLinkToLogLine?: unknown;
  displayedFields?: Array<string>;
  fieldSelectorWidth?: number;
  setDisplayedFields?: unknown;
  showControls?: boolean;
  showCopyLogLink?: boolean;
  showInspectLogLine?: boolean;
  sortOrder?: common.LogsSortOrder;
}

export const defaultOptions: Partial<Options> = {
  displayedFields: [],
  fieldSelectorWidth: 220,
  showControls: true,
  showCopyLogLink: false,
  showInspectLogLine: true,
  sortOrder: common.LogsSortOrder.Descending,
};
